import { useQuery, useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

async function fetchDiagnosticQuestions() {
  const res = await apiClient.get("/api/v1/diagnostic/");
  return res.data;
}

async function submitDiagnostic(answers) {
  const res = await apiClient.post("/api/v1/diagnostic/submit/", { answers });
  return res.data;
}

function useDiagnosticQuestions() {
  return useQuery({
    queryKey: ["student", "diagnostic"],
    queryFn: fetchDiagnosticQuestions,
  });
}

function useDiagnosticSubmit() {
  return useMutation({ mutationFn: submitDiagnostic });
}

export { useDiagnosticQuestions, useDiagnosticSubmit };
